import { orderFillsByVenueTypeCapsuleDescription } from './components/description/orderFillsByVenueTypeCapsuleDescription';
import { toVenueTypeCapsuleDisplayData } from '../venueTypeCapsule/components/content/VenueTypeCapsuleContentFront';
import { Tooltip } from '@instinet-analytics/core-lib';
import React from 'react';
import { OrderFillsCapsuleStrategy } from '../orderFillsCapsulesShared/orderFillsCapsuleStrategy';

export const orderFillsByVenueTypeCapsuleStrategy: OrderFillsCapsuleStrategy = {
    title: 'Order Fills by Venue Type',
    description: orderFillsByVenueTypeCapsuleDescription,
    helpText: `This capsule displays your order's venue type usage.`,
    getOrderDisplayData: (data) => toVenueTypeCapsuleDisplayData(data).order,
    renderLabel: (v, percentText: string) => (
        <Tooltip text={`${v.name} (${percentText})`}>{v.name}</Tooltip>
    ),
};
